import React, { useState, useEffect } from 'react';

import { CardGiftcard } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { 
  Character
} from "@dndModels";

import CharacterGiftInput from "@dndComponents/character/gifts/CharacterGiftInput";
import CharacterExtraFeatInput from "@dndComponents/character/gifts/CharacterExtraFeatInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  character: Character;
  recalc_time: number;
  disabled: boolean;
  onChange: (changed: Character) => void;
}

export default function CharacterGiftButton({
  character,
  recalc_time,
  disabled,
  onChange
}: Props) {
  const [flashing, setFlashing] = useState((
    character.gifts.filter(o => 
      o.needs_attention).length > 0 || 
    character.extra_feats.filter(o => 
      o.needs_attention).length > 0
  ));
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("Extra Feats");
  const [prev_recalc_time, setRecalcTime] = useState(recalc_time);
  
  useEffect(() => {
    if (recalc_time !== prev_recalc_time) {
      setRecalcTime(recalc_time);
      if (character.gifts.filter(o => o.needs_attention).length > 0) {
        if (!flashing) {
          setFlashing(true);
        }
      } else if (flashing) {
        setFlashing(false);
      }
    }
    // eslint-disable-next-line
  }, [recalc_time]);

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        // drawer_only
        width={ wide_mode ? 800 : undefined }
        full_page
        // drawer_only
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row" 
            style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              size={{
                xs: 12
              }}>                
              <CenteredMenu
                options={["Extra Feats","Gifts"]}
                selected={view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              { view === "Gifts" ? 
                <CharacterGiftInput
                  character={character}
                  onChange={(changed: Character, do_main: boolean) => {
                    // debugger;
                    character.changed();
                    onChange(changed);
                  }}
                />
              :
                <CharacterExtraFeatInput
                  character={character}
                  onChange={(changed: Character, do_main: boolean) => {
                    character.changed();
                    onChange(changed);
                  }}
                />
              }
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Extra Feats &amp; Gifts">
        <CardGiftcard
          className="clickable"
          onClick={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}
